'use client';

// useServices — returns only activities with category === 'transport'.
// Transport items have no public pages; they surface as upsells via
// ServiceRecommendation in lodge/activity flows. This hook keeps the
// filter in one place so all consumers agree.
import { useActivities, type Activity } from './useActivities';

export type Service = Activity;

export function useServices() {
  const { activities, loading, error } = useActivities();
  const services = activities.filter((a) => a.category === 'transport');
  return { services, loading, error };
}
